import React, { useState } from 'react';
import { Coins, Loader2, Send } from 'lucide-react';
import { toast } from 'sonner';
import api from '../../lib/api';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';

// Ask finance to approve a value per 1% for an unpriced KPI; org admins get a notification.
export default function ValueUnitRequestDialog({ kpi, organizationId, onOpenChange, onSent }) {
  const [note, setNote] = useState('');
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try {
      const body = { kpi_id: kpi.kpi_id, note };
      if (organizationId && organizationId !== '_all') body.organization_id = organizationId;
      const r = await api.post('/performance-health/value-unit-requests', body);
      toast.success(r.data.notified ? `Request sent to ${r.data.notified} admin${r.data.notified !== 1 ? 's' : ''}` : 'Request recorded');
      onSent?.(r.data.request); onOpenChange(false);
    } catch (e) { toast.error(e.response?.data?.detail || e.message); }
    finally { setBusy(false); }
  };
  return (
    <Dialog open={!!kpi} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="value-unit-request-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-base"><Coins className="h-4 w-4" /> Request a value unit</DialogTitle>
          <DialogDescription className="text-xs">Ask finance to approve a value per 1% improvement for <strong>{kpi?.name}</strong>. Until it is priced, this KPI’s movement is not counted in Financial Health.</DialogDescription>
        </DialogHeader>
        <textarea value={note} onChange={(e) => setNote(e.target.value.slice(0, 300))} rows={3} placeholder="Optional context for finance — e.g. why this KPI matters now, a suggested value or its source" className="w-full rounded-md border border-slate-200 bg-white p-2 text-xs" data-testid="value-unit-request-note" />
        <div className="flex items-center justify-between gap-2"><span className="text-[10px] text-slate-400">{note.length}/300</span><Button size="sm" onClick={send} disabled={busy} className="bg-orange-600 hover:bg-orange-700" data-testid="value-unit-request-send">{busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Send className="h-3.5 w-3.5" />} Send request</Button></div>
      </DialogContent>
    </Dialog>
  );
}
